module.exports = __webpack_public_path__ + "img/banner_tail.92f981ce.svg";